import React, { useState, useEffect } from "react";
import "./App.css";
import ReactEcharts from "echarts-for-react";
import {
  Button,
  Drawer,
  Menu,
  Dropdown,
  Tabs,
  Popover,
  Tag,
  Collapse,
  Input,
  Switch,
  message,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { SketchPicker } from "react-color";
import ReactDataSheet from "react-datasheet";
import "react-datasheet/lib/react-datasheet.css";

import "antd/dist/antd.css";

import bin from "./style/image/bin.png";
import mian from "./style/image/mian.png";
import san from "./style/image/san.png";
import tiao from "./style/image/tiao.png";
import zhe from "./style/image/zhe.png";
import zhu from "./style/image/zhu.png";
import echarts from "echarts";
import Series from "./Series";
import SourcePicker from "./SourcePicker";
import ColFilter from "./ColFilter";

const menuIten = [
  { name: "柱状图", img: zhu, type: "bar" },
  { name: "折线图", img: zhe, type: "line" },
  { name: "饼图", img: bin, type: "pie" },
  { name: "条形图", img: tiao, type: "bar" },
  { name: "面积图", img: mian, type: "line" },
  { name: "散点图", img: san, type: "scatter" },
];

const { TabPane } = Tabs;
const { Panel } = Collapse;

echarts.registerTheme("my_theme", {
  backgroundColor: "#fff",
});

const source = [120, 200, 150, 80, 70, 110, 130];

const defaultOption = {
  title: {
    text: "title",
  },
  xAxis: {
    type: "category",
  },
  yAxis: {
    type: "value",
  },
  legend: {
    type: "plain",
    show: true,
    top: "20px",
    left: "left",
  },
  series: [
    {
      name: "test",
      data: source,
      type: "line",
      showBackground: true,
      backgroundStyle: {
        color: "rgba(220, 220, 220, 0.8)",
      },
    },
  ],
};

const option2 = {
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : {c} ({d}%)",
  },
  series: [
    {
      name: "test",
      type: "pie",
      radius: "55%",
      center: ["50%", "50%"],
      data: [
        { value: source[0], name: "1" },
        { value: source[1], name: "2" },
        { value: source[2], name: "3" },
        { value: source[3], name: "4" },
        { value: source[4], name: "5" },
        { value: source[5], name: "6" },
        { value: source[6], name: "7" },
      ],
      labelLine: {
        smooth: 0.2,
        length: 10,
        length2: 20,
      },
    },
  ],
};

const fontFamilyList = [
  "sans-serif",
  "serif",
  "monospace",
  "Arial",
  "Courier New",
  "Microsoft YaHei",
];

const fontSizeList = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22];
const positionList = ["左上", "中间", "右上"];
const rotateList = [0, 30, 60, 90];

const dataPositionList = ["上", "中间", "下"];

const lineType = ["实线", "虚线", "点阵"];

const lineWidthList = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

const symbolList = [
  "emptyCircle",
  "rect",
  "circle",
  "roundRect",
  "triangle",
  "diamond",
  "pin",
  "arrow",
  "none",
];

const radiusList = [20, 30, 40, 50, 60, 70, 80];

const colorList = [
  "#f17b7d",
  "#88b6e8",
  "#6fd23e",
  "#f9c050",
  "#756c59",
  "#ff7875",
  "#bedeae",
  "#0062cc",
  "#ca575c",
  "#ffe3ab",
];

const defaultDisplayCol = () => {
  const result = [
    {
      value: "A",
      width: 300,
      readOnly: true,
      rowIndex: 0,
      colIndex: 0,
    },
    {
      value: "B",
      width: 300,
      readOnly: true,
      rowIndex: 0,
      colIndex: 1,
    },
    {
      value: "C",
      width: 300,
      readOnly: true,
      rowIndex: 0,
      colIndex: 2,
    },
    {
      value: "D",
      width: 300,
      readOnly: true,
      rowIndex: 0,
      colIndex: 3,
    },
    {
      value: "E",
      width: 300,
      readOnly: true,
      rowIndex: 0,
      colIndex: 4,
    },
    {
      value: "F",
      width: 300,
      readOnly: true,
      disableEvents: true,
      rowIndex: 0,
      colIndex: 5,
    },
    {
      value: "G",
      width: 300,
      readOnly: true,
      disableEvents: true,
      rowIndex: 0,
      colIndex: 6,
    },
  ];

  return result;
};

const transfromColSetToRowSet = (colSet: [][]) => {
  const result: any[] = [];

  let count = 0;
  for (let i = 0; i < colSet.length; i++) {
    if (colSet[i].length > count) count = colSet[i].length;
  }

  for (let rowNumber = 0; rowNumber < count; rowNumber++) {
    const row: any[] = [];
    for (let colNumber = 0; colNumber < colSet.length; colNumber++) {
      if (colSet[colNumber][rowNumber]) {
        row.push(colSet[colNumber][rowNumber]);
      } else {
        row.push({
          value: "",
          colIndex: colNumber,
          rowIndex: rowNumber,
          width: 200,
        });
      }
    }
    result.push(row);
  }

  return result;
};

function App() {
  const generateGrid = () => {
    const result: any[] = [];
    for (let col = 0; col < 7; col++) {
      const colSet: any[] = [];
      colSet.push({
        value: "title",
        width: 300,
        readOnly: true,
        disableEvents: true,
        rowIndex: 0,
        colIndex: col,
      });
      for (let row = 1; row < 20; row++) {
        colSet.push({
          value: "",
          rowIndex: row,
          colIndex: col,
          width: 200,
        });
      }
      result.push(colSet);
    }

    return result;
  };

  let dasheetSelected: any = null;

  const [grid, setGrid] = useState(generateGrid());
  const [gridSource, setGridSource] = useState(generateGrid());
  const [displayColNames, setDisplayColNames] = useState(defaultDisplayCol);
  const [filteredGrid, setFilteredGrid] = useState(
    transfromColSetToRowSet(generateGrid())
  );

  const [type, setType] = useState("折线图");
  // eslint-disable-next-line
  const [option, setOption] = useState<any>(defaultOption);
  const [optionSource, setOptionSource] = useState(defaultOption);
  const [filterList, setFilterList] = useState<any[]>([]);

  const [color, setColor] = useState<string>("rgb(190, 44, 44)");
  const [fontColor, setFontColor] = useState<string>("rgb(144, 19, 254)");
  const [title, setTitle] = useState<string>("title");
  const [legendFontColor, setLegendFontColor] = useState<string>(
    "rgb(51, 219, 24)"
  );
  const [fontFamily, setFontFamily] = useState<string>("sans-serif");
  const [fontSize, setFontSize] = useState<number>(12);

  const [xAxisFontColor, setXAxisFontColor] = useState<string>(
    "rgb(14, 19, 114)"
  );
  const [xAxisfontFamily, setXAxisFontFamily] = useState<string>("sans-serif");
  const [xAxisfontSize, setXAxisFontSize] = useState<number>(12);
  const [xAxisroTate, setXAxisroTate] = useState<number>(0);
  const [xAxisTitle, setXAxisTitle] = useState<string>("横轴标题");
  const [xAxisTitleFontFamily, setXAxisTitleFontFamily] = useState<string>(
    fontFamilyList[0]
  );
  const [xAxisTitleFontSize, setXAxisTitleFontSize] = useState<number>(
    fontSizeList[1]
  );
  const [xAxisTitleFontColor, setXAxisTitleFontColor] = useState<string>(
    "rgb(44, 19, 14)"
  );

  const [yAxisFontColor, setYAxisFontColor] = useState<string>(
    "rgb(84, 49, 24)"
  );
  const [yAxisfontFamily, setYAxisFontFamily] = useState<string>("sans-serif");
  const [yAxisfontSize, setYAxisFontSize] = useState<number>(12);
  const [yAxisroTate, setYAxisroTate] = useState<number>(0);
  const [yAxisTitle, setYAxisTitle] = useState<string>("");
  const [yAxisTitleFontFamily, setYAxisTitleFontFamily] = useState<string>(
    fontFamilyList[0]
  );
  const [yAxisTitleFontSize, setYAxisTitleFontSize] = useState<number>(
    fontSizeList[1]
  );
  const [yAxisTitleFontColor, setYAxisTitleFontColor] = useState<string>(
    "rgb(144, 139, 14)"
  );

  const [legendPosition, setLegendPosition] = useState<string>("左上");
  // eslint-disable-next-line
  const [barColor, setBarColor] = useState<string>("rgb(244, 119, 4)");

  const [dataPosition, setDataPosition] = useState<string>(dataPositionList[0]);
  const [dataFontFamily, setDataFontFamily] = useState<string>("sans-serif");
  const [dataFontSize, setDataFontSize] = useState<number>(12);
  const [dataFontColor, setDataFontColor] = useState<string>(
    "rgb(144, 19, 254)"
  );

  const [lineStyle, setLineStyle] = useState<string>(lineType[0]);
  const [lineWidth, setLineWidth] = useState<number>(2);
  const [lineSymbol, setLineSymbol] = useState<string>(symbolList[0]);
  const [lineSymbolSize, setLineSymbolSize] = useState<number>(2);

  const [pieRadius, setPieRadius] = useState<number>(radiusList[0]);

  const [showAllInfo, setShowAllInfo] = useState<boolean>(true);

  const [currentPiePart, setCurrentPiePart] = useState<string>("1");
  // eslint-disable-next-line
  const [xAxisName, setxAxisName] = useState<any>([]);
  // eslint-disable-next-line
  const [currentPiePartColor, setCurrentPiePartColor] = useState<string>(
    "rgb(22, 22, 254)"
  );

  const [series, setSeries] = useState<any>();

  const [autoUpdateList, setAutoUpdateList] = useState([]);

  useEffect(() => {
    setFilteredGrid(filteredGirdSource());
    // eslint-disable-next-line
  }, [gridSource, filterList, displayColNames]);

  const handleSwitchType = (type: string) => {
    if (!series) {
      message.error("请先设置数据");
      return;
    }
    const flag = doSetOption(type);
    if (flag) {
      setType(type);
    }
  };

  const doSetOption = (type: string, myOption?: any) => {
    const copyOption = myOption
      ? myOption
      : JSON.parse(JSON.stringify(optionSource));
    setOptionSource(JSON.parse(JSON.stringify(copyOption)));
    const mySeries = copyOption.series;
    mySeries.map((s: any) => {
      s.itemStyle = {};
      return s;
    });
    let newSeries;
    switch (type) {
      case "柱状图":
        newSeries = mySeries.map((s: any) => {
          return {
            name: s.name,
            data: s.data,
            type: "bar",
          };
        });
        copyOption.xAxis = {
          type: "category",
        };
        copyOption.yAxis = {
          type: "value",
          boundaryGap: [0, 0.01],
        };
        copyOption.series = newSeries;
        setOption(copyOption);
        break;
      case "折线图":
        copyOption.xAxis = {
          type: "category",
        };
        copyOption.yAxis = {
          type: "value",
          boundaryGap: [0, 0.01],
        };
        newSeries = mySeries.map((s: any) => {
          s.type = "line";
          s.areaStyle = null;
          return s;
        });
        copyOption.series = newSeries;
        setOption(copyOption);
        break;
      case "饼图":
        if (mySeries.length > 2) {
          message.error("一次最多只能画两张饼图");
          return false;
        }
        newSeries = JSON.parse(JSON.stringify(mySeries)).map(
          (s: any, index: number) => {
            const countMap: Map<string, number> = new Map();

            s.data.map((d: any, index: number) => {
              if (countMap.has(d.value)) {
                const count = countMap.get(d.value);
                if (count) countMap.set(d.value, count + 1);
              } else {
                countMap.set(d.value, 1);
              }
              return d;
            });
            const newdata: any = [];
            countMap.forEach(function (value, key, map) {
              newdata.push({
                itemStyle: {
                  color: colorList[Math.floor(Math.random() * 11)],
                },
                name: key,
                value: value,
              });
            });

            return {
              name: s.name,
              data: newdata,
              type: "pie",
              radius: "55%",
              label: {
                show: true,
                formatter: " {a} {b} ({d}%)",
              },
              center: [(index / mySeries.length) * 100 + 30 + "%", "50%"],
              labelLine: {
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            };
          }
        );
        newSeries.tooltip = {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        };
        copyOption.xAxis = null;
        copyOption.yAxis = null;
        copyOption.series = newSeries;
        setOption(copyOption);
        break;
      case "条形图":
        copyOption.xAxis = {
          type: "value",
          boundaryGap: [0, 0.01],
        };
        copyOption.yAxis = {
          type: "category",
          data: ["1", "2", "3", "4", "5", "6", "7"],
        };
        newSeries = mySeries.map((s: any) => {
          s.type = "bar";
          return s;
        });
        copyOption.series = newSeries;
        setOption(copyOption);
        break;
      case "面积图":
        copyOption.xAxis = {
          type: "category",
        };
        copyOption.yAxis = {
          type: "value",
          boundaryGap: [0, 0.01],
        };
        newSeries = mySeries.map((s: any) => {
          s.type = "line";
          s.areaStyle = {};
          return s;
        });
        copyOption.series = newSeries;
        setOption(copyOption);
        break;
      case "散点图":
        if (mySeries.length < 1) {
          message.error("至少选择两列才能画散点");
          return false;
        }
        const scatterSeries: any = [];
        newSeries = mySeries.map((s: any, index: number) => {
          if (index > 0) {
            s.type = "scatter";
            s.symbolSize = 20;
            s.data = s.data.map((data: any, i: number) => {
              const newD = [];
              newD.push(mySeries[0].data[i].value);
              newD.push(data.value);
              return newD;
            });
            scatterSeries.push(s);
          }
          return s;
        });
        copyOption.series = scatterSeries;
        setOption(copyOption);
        break;
      default:
        break;
    }
    return true;
  };

  const handleSetData = () => {
    if (!dasheetSelected) {
      message.error("你还没有选中数据！");
      return;
    }
    let currentJ = dasheetSelected.start.j;
    const grid = filteredGrid;
    if (
      type === "饼图" &&
      dasheetSelected.end.j - dasheetSelected.start.j > 1
    ) {
      message.error("一次最多只能画两张饼图");
      return;
    }
    if (
      type === "散点图" &&
      dasheetSelected.end.j - dasheetSelected.start.j > 1
    ) {
      message.error("至少选择两列才能画散点图");
    }
    const all = [];
    let xAxisName = [];
    for (currentJ; currentJ <= dasheetSelected.end.j; currentJ++) {
      const col = [];
      let currentI = dasheetSelected.start.i;
      xAxisName = [];
      for (currentI; currentI <= dasheetSelected.end.i; currentI++) {
        col.push({
          value: grid[currentI][currentJ].value,
          name: grid[currentI][currentJ].value,
        });
        xAxisName.push(grid[currentI][0].value);
      }
      all.push(col);
    }
    setxAxisName(xAxisName);
    const item = menuIten.find((item) => {
      return item.name === type;
    });
    let i = dasheetSelected.start.j;
    const titles: any = [];
    for (i; i <= dasheetSelected.end.j; i++) {
      titles.push(grid[0][i].value);
    }
    const series = all.map((obj, index) => {
      return {
        data: obj,
        type: item?.type,
        name: titles[index],
      };
    });
    const copyOption = JSON.parse(JSON.stringify(option));
    copyOption.series = series;
    setSeries(JSON.parse(JSON.stringify(series)));
    doSetOption(type, copyOption);
  };

  const handleChangeBackGroudColor = (color: any) => {
    setOption({
      backgroundColor: color.hex,
    });
    setColor(color.hex);
  };

  //title
  const handleSwitchTitleFontFamily = (fontFamily: string) => {
    setFontFamily(fontFamily);
    setOption({
      title: {
        textStyle: {
          fontFamily: fontFamily,
        },
      },
    });
  };

  const handleSwitchTitleFontSize = (fontsize: number) => {
    setFontSize(fontsize);
    setOption({
      title: {
        textStyle: {
          fontSize: fontsize,
        },
      },
    });
  };

  const handleSwitchTitleFontColor = (color: any) => {
    setOption({
      title: {
        textStyle: {
          color: color.hex,
        },
      },
    });
    setFontColor(color.hex);
  };

  //Legend
  const handleSwitchLegendFontFamily = (fontFamily: string) => {
    setFontFamily(fontFamily);
    setOption({
      legend: {
        textStyle: {
          fontFamily: fontFamily,
        },
      },
    });
  };

  const handleSwitchLegendFontSize = (fontsize: number) => {
    setFontSize(fontsize);
    setOption({
      legend: {
        textStyle: {
          fontSize: fontsize,
        },
      },
    });
  };

  const handleSwitchLegendFontColor = (color: any) => {
    setOption({
      legend: {
        textStyle: {
          color: color.hex,
        },
      },
    });
    setLegendFontColor(color.hex);
  };

  //XAxis
  const handleSwitchXAxisFontColor = (color: any) => {
    setOption({
      xAxis: {
        axisLabel: {
          color: color.hex,
        },
      },
    });
    setXAxisFontColor(color.hex);
  };

  const handleSwitchXAxisFontSize = (fontSize: number) => {
    setOption({
      xAxis: {
        axisLabel: {
          fontSize: fontSize,
        },
      },
    });
    setXAxisFontSize(fontSize);
  };

  const handleSwitchXAxisFontFamily = (fontFamily: string) => {
    setXAxisFontFamily(fontFamily);
    setOption({
      xAxis: {
        axisLabel: {
          fontFamily: fontFamily,
        },
      },
    });
  };

  const handleSwitchXAxisRotate = (rotate: number) => {
    setXAxisroTate(rotate);
    setOption({
      xAxis: {
        axisLabel: {
          rotate: rotate,
        },
      },
    });
  };

  const handleSwitchXAxisTitleFontFamily = (fontFamily: string) => {
    setXAxisTitleFontFamily(fontFamily);
    setOption({
      xAxis: {
        nameTextStyle: {
          fontFamily: fontFamily,
        },
      },
    });
  };

  const handleSwitchXAxisTitleFontColor = (color: any) => {
    setOption({
      xAxis: {
        nameTextStyle: {
          color: color.hex,
        },
      },
    });
    setXAxisTitleFontColor(color.hex);
  };

  const handleSwitchXAxisTitleFontSize = (fontSize: number) => {
    setOption({
      xAxis: {
        nameTextStyle: {
          fontSize: fontSize,
        },
      },
    });
    setXAxisTitleFontSize(fontSize);
  };

  //YAxis
  const handleSwitchYAxisFontColor = (color: any) => {
    setYAxisFontColor(color.hex);
    setOption({
      yAxis: {
        axisLabel: {
          color: color.hex,
        },
      },
    });
  };

  const handleSwitchYAxisFontSize = (fontSize: number) => {
    setOption({
      yAxis: {
        axisLabel: {
          fontSize: fontSize,
        },
      },
    });
    setYAxisFontSize(fontSize);
  };

  const handleSwitchYAxisFontFamily = (fontFamily: string) => {
    setYAxisFontFamily(fontFamily);
    setOption({
      yAxis: {
        axisLabel: {
          fontFamily: fontFamily,
        },
      },
    });
  };

  const handleSwitchYAxisTitleFontFamily = (fontFamily: string) => {
    setYAxisTitleFontFamily(fontFamily);
    setOption({
      yAxis: {
        nameTextStyle: {
          fontFamily: fontFamily,
        },
      },
    });
  };

  const handleSwitchYAxisTitleFontColor = (color: any) => {
    setOption({
      yAxis: {
        nameTextStyle: {
          color: color.hex,
        },
      },
    });
    setYAxisTitleFontColor(color.hex);
  };

  const handleSwitchYAxisTitleFontSize = (fontSize: number) => {
    setOption({
      yAxis: {
        nameTextStyle: {
          fontSize: fontSize,
        },
      },
    });
    setYAxisTitleFontSize(fontSize);
  };

  const handleSwitchYAxisRotate = (rotate: number) => {
    setYAxisroTate(rotate);
    setOption({
      yAxis: {
        axisLabel: {
          rotate: rotate,
        },
      },
    });
  };

  //data
  const handleSwitchDataFontColor = (color: any) => {
    setDataFontColor(color.hex);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.label = {
        show: true,
        color: color.hex,
      };
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const handleSwitchDataFontFamily = (fontFamily: string) => {
    setDataFontFamily(fontFamily);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.label = {
        show: true,
        fontFamily: fontFamily,
      };
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const handleSwitchDataFontSize = (fontSize: number) => {
    setDataFontSize(fontSize);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.label = {
        show: true,
        fontSize: fontSize,
      };
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const positionMap = [
    { key: "上", value: "top" },
    { key: "中间", value: "inside" },
    { key: "下", value: "bottom" },
  ];

  const handleSwitchDataPostion = (position: string) => {
    const find = positionMap.find((p) => {
      return p.key === position;
    });
    if (find) {
      setDataPosition(position);
      const newOption = { ...option };
      const series = newOption.series;
      const result = series.map((s: any) => {
        const newS = { ...s };
        newS.label = {
          show: true,
          position: find.value,
        };
        return newS;
      });

      newOption.series = result;
      setOption(newOption);
    }
  };

  //handleSwitchBarColor
  // const handleSwitchBarColor = (color: any) => {
  //   setBarColor(color.hex);
  //   setOption({
  //     color: color.hex,
  //   });
  // };

  const lineTypeMap = [
    { key: "实线", value: "solid" },
    { key: "虚线", value: "dashed" },
    { key: "点阵", value: "dotted" },
  ];

  //折线图类型
  const handleSwitchLineStyle = (lineType: any) => {
    const find = lineTypeMap.find((item) => {
      return item.key === lineType;
    });
    if (find) {
      setLineStyle(lineType);
      const newOption = { ...option };
      const series = newOption.series;
      const result = series.map((s: any) => {
        const newS = { ...s };
        newS.lineStyle = {
          type: find.value,
        };
        return newS;
      });

      newOption.series = result;
      setOption(newOption);
    }
  };

  const handleSwitchLineWidth = (lineWidth: any) => {
    setLineWidth(lineWidth);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.lineStyle = {
        width: lineWidth,
      };
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const handleSwitchSymbol = (lineSymbol: any) => {
    setLineSymbol(lineSymbol);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.symbol = lineSymbol;
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const handleSwitchSymbolSize = (lineSymbolSize: any) => {
    setLineSymbolSize(lineSymbolSize);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.symbolSize = lineSymbolSize;
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const handleSwitchPieRadius = (pieRadius: any) => {
    setPieRadius(pieRadius);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      newS.radius = [pieRadius + "%", "55%"];
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const handleSwitchShowAllInfo = (checked: boolean) => {
    setShowAllInfo(checked);
    const newOption = { ...option };
    const series = newOption.series;
    const result = series.map((s: any) => {
      const newS = { ...s };
      if (checked) {
        newS.label = {
          show: true,
          formatter: " {a} {b} ({d}%)",
        };
      } else {
        newS.label = {
          show: true,
          formatter: " {a}",
        };
      }
      return newS;
    });

    newOption.series = result;
    setOption(newOption);
  };

  const legendPostionMenu = (
    <Menu>
      {positionList.map((item, index) => {
        return (
          <Menu.Item key={item}>
            <div
              onClick={() => {
                handleSetLegendPosition(item);
              }}
            >
              {item}
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const fontFamilyMenu = (clickFn: Function) => (
    <Menu>
      {fontFamilyList.map((item, index) => {
        return (
          <Menu.Item key={item}>
            <div
              onClick={() => {
                clickFn(item);
              }}
            >
              {item}
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const fontSizeMenu = (clickFn: Function) => (
    <Menu>
      {fontSizeList.map((item, index) => {
        return (
          <Menu.Item key={item}>
            <div
              onClick={() => {
                clickFn(item);
              }}
            >
              {item}
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const customMenu = (clickFn: Function, list: Array<any>) => (
    <Menu>
      {list.map((item, index) => {
        return (
          <Menu.Item key={item}>
            <div
              onClick={() => {
                clickFn(item);
              }}
            >
              {item}
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const handleSetLegendPosition = (position: string) => {
    setLegendPosition(position);
    switch (position) {
      case "左上":
        setOption({
          legend: {
            type: "plain",
            show: true,
            top: "20px",
            left: "left",
          },
        });
        break;
      case "中间":
        setOption({
          legend: {
            type: "plain",
            show: true,
            top: "20px",
            left: "40%",
          },
        });
        break;
      case "右上":
        setOption({
          legend: {
            type: "plain",
            show: true,
            top: "20px",
            left: "right",
          },
        });
        break;
      default:
        break;
    }
  };

  const filteredGirdSource = () => {
    let copyGrid = JSON.parse(JSON.stringify(gridSource));

    if (filterList.length) {
      filterList.forEach((filter: any) => {
        if (filter.filters.length) {
          const newCol: any[] = [];
          copyGrid[filter.col].forEach((cell: any) => {
            if (filter.filters.includes(cell.value)) {
              newCol.push(cell);
            }
          });
          copyGrid[filter.col] = newCol;
        }
      });
    }

    const result = transfromColSetToRowSet(copyGrid);
    result.shift();
    return result;
  };

  return (
    <div>
      <div>
        <div style={{ width: 1000, height: 350, margin: "30px 0px 0px 80px" }}>
          <div>
            <h2>云变量 图表绘制</h2>
          </div>
          <ReactEcharts
            option={option}
            style={{ height: "350px", width: "100%" }}
            className="react_for_echarts"
            theme="my_theme"
            notMerge={true}
          />
        </div>
        <SourcePicker
          grid={grid}
          setGrid={setGrid}
          gridSource={gridSource}
          setGridSource={setGridSource}
          displayColNames={displayColNames}
          setDisplayColNames={setDisplayColNames}
          filterList={filterList}
          setFilterList={setFilterList}
        ></SourcePicker>
        <div style={{ margin: "20px 20px" }}>
          <div style={{ width: "1000px", height: "40px" }}>
            <Button
              type="primary"
              onClick={() => {
                handleSetData();
              }}
              style={{ marginLeft: 10, marginBottom: 10 }}
            >
              设置数据
            </Button>
          </div>
          <div id={"dataSheet"} style={{ height: 600, overflow: "scroll" }}>
            <ReactDataSheet
              data={filteredGrid}
              valueRenderer={(cell: any) => cell.value}
              onCellsChanged={(changes: any) => {
                const copySource = JSON.parse(JSON.stringify(gridSource));
                changes.forEach(({ cell, row, col, value }: any) => {
                  copySource[cell.colIndex][cell.rowIndex] = {
                    ...copySource[cell.colIndex][cell.rowIndex],
                    value,
                  };
                });
                setGridSource(copySource);
              }}
              onSelect={(selection) => {
                dasheetSelected = selection;
              }}
              rowRenderer={(props) => (
                <tr>
                  <td className="cell read-only">
                    <span>{props.row}</span>
                  </td>
                  {props.children}
                </tr>
              )}
              sheetRenderer={(props) => (
                <table className={props.className + " my-awesome-extra-class"}>
                  <thead>
                    <tr>
                      <th className="action-cell" />
                      {displayColNames.map((col, index) => (
                        <td className="cell read-only" key={index}>
                          <ColFilter
                            col={index}
                            grid={grid}
                            setGrid={setGrid}
                            gridSource={gridSource}
                            setGridSource={setGridSource}
                            filterList={filterList}
                            setFilterList={setFilterList}
                            displayColNames={displayColNames}
                            setDisplayColNames={setDisplayColNames}
                            autoUpdateList={autoUpdateList}
                            setAutoUpdateList={setAutoUpdateList}
                            children={<span>{col.value}</span>}
                          />
                        </td>
                      ))}
                    </tr>
                  </thead>
                  <tbody>{props.children}</tbody>
                </table>
              )}
            />
          </div>
        </div>
        <div>
          <Drawer
            title="图表设置"
            placement="right"
            closable={false}
            visible={true}
            width={350}
            mask={false}
          >
            <Tabs defaultActiveKey="1" animated={true}>
              <TabPane tab="设置" key="1">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {menuIten.map((item) => {
                    return (
                      <div key={item.name}>
                        <label>{item.name}</label>
                        <div>
                          <img
                            src={item.img}
                            alt={item.name}
                            onClick={() => {
                              handleSwitchType(item.name);
                            }}
                            style={{ cursor: "pointer" }}
                          ></img>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TabPane>
              <TabPane tab="自定义" key="2">
                <Collapse accordion>
                  <Panel header="图表样式" key="1">
                    <div>
                      <Popover
                        placement="leftTop"
                        title={"背景颜色"}
                        content={
                          <SketchPicker
                            color={color}
                            onChangeComplete={handleChangeBackGroudColor}
                          ></SketchPicker>
                        }
                        trigger="click"
                      >
                        <Tag color={color} style={{ cursor: "pointer" }}>
                          背景颜色
                        </Tag>
                      </Popover>
                    </div>
                  </Panel>
                  <Panel header="图标标题" key="2">
                    <div className="option-item">
                      <label>图标标题</label>
                      <Input
                        size="large"
                        placeholder={title}
                        onChange={(event: any) => {
                          setTitle(event.target.value);
                          setOption({
                            title: {
                              text: event.target.value,
                            },
                          });
                        }}
                      ></Input>
                    </div>
                    <div style={{ display: "flex" }} className="option-item">
                      <div style={{ flexGrow: 5 }}>
                        <label>标题字体</label>
                        <div>
                          <Dropdown
                            overlay={fontFamilyMenu(
                              handleSwitchTitleFontFamily
                            )}
                          >
                            <span>
                              {fontFamily} <DownOutlined />
                            </span>
                          </Dropdown>
                        </div>
                      </div>
                      <div style={{ flexGrow: 5 }}>
                        <label>标题字号</label>
                        <div>
                          <Dropdown
                            overlay={fontSizeMenu(handleSwitchTitleFontSize)}
                          >
                            <span>
                              {fontSize} <DownOutlined />
                            </span>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                    <div className="option-item">
                      <Popover
                        placement="leftTop"
                        title={"背景颜色"}
                        content={
                          <SketchPicker
                            color={fontColor}
                            onChangeComplete={handleSwitchTitleFontColor}
                          ></SketchPicker>
                        }
                        trigger="click"
                      >
                        <Tag color={fontColor} style={{ cursor: "pointer" }}>
                          字体颜色
                        </Tag>
                      </Popover>
                    </div>
                  </Panel>
                  <Panel header="图例" key="3">
                    <div className="option-item">
                      <label>图例位置 </label>
                      <Dropdown overlay={legendPostionMenu}>
                        <span>
                          {legendPosition} <DownOutlined />
                        </span>
                      </Dropdown>
                    </div>
                    <div style={{ display: "flex" }} className="option-item">
                      <div style={{ flexGrow: 5 }}>
                        <label>图例字体</label>
                        <div>
                          <Dropdown
                            overlay={fontFamilyMenu(
                              handleSwitchLegendFontFamily
                            )}
                          >
                            <span>
                              {fontFamily} <DownOutlined />
                            </span>
                          </Dropdown>
                        </div>
                      </div>
                      <div style={{ flexGrow: 5 }}>
                        <label>图例字号</label>
                        <div>
                          <Dropdown
                            overlay={fontSizeMenu(handleSwitchLegendFontSize)}
                          >
                            <span>
                              {fontSize} <DownOutlined />
                            </span>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <Popover
                          placement="leftTop"
                          title={"字体颜色"}
                          content={
                            <SketchPicker
                              color={legendFontColor}
                              onChangeComplete={handleSwitchLegendFontColor}
                            ></SketchPicker>
                          }
                          trigger="click"
                        >
                          <Tag
                            color={legendFontColor}
                            style={{ cursor: "pointer" }}
                          >
                            字体颜色
                          </Tag>
                        </Popover>
                      </div>
                    </div>
                  </Panel>
                  {type === "饼图" ? (
                    ""
                  ) : (
                    <Panel header="横轴" key="4">
                      <div className="option-item">
                        <Input
                          size="large"
                          placeholder={xAxisTitle}
                          onChange={(event: any) => {
                            setXAxisTitle(event.target.value);
                            setOption({
                              xAxis: {
                                name: event.target.value,
                              },
                            });
                          }}
                        ></Input>
                      </div>
                      <div style={{ display: "flex" }} className="option-item">
                        <div style={{ flexGrow: 5 }}>
                          <label>标题字体</label>
                          <div>
                            <Dropdown
                              overlay={fontFamilyMenu(
                                handleSwitchXAxisTitleFontFamily
                              )}
                            >
                              <span>
                                {xAxisTitleFontFamily} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                        <div style={{ flexGrow: 5 }}>
                          <label>标题字号</label>
                          <div>
                            <Dropdown
                              overlay={fontSizeMenu(
                                handleSwitchXAxisTitleFontSize
                              )}
                            >
                              <span>
                                {xAxisTitleFontSize} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                      <div className="option-item">
                        <Popover
                          placement="leftTop"
                          title={"字体颜色"}
                          content={
                            <SketchPicker
                              color={xAxisTitleFontColor}
                              onChangeComplete={handleSwitchXAxisTitleFontColor}
                            ></SketchPicker>
                          }
                          trigger="click"
                        >
                          <Tag
                            color={xAxisTitleFontColor}
                            style={{ cursor: "pointer" }}
                          >
                            标题颜色
                          </Tag>
                        </Popover>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flexGrow: 5 }}>
                          <label>横轴字体</label>
                          <div>
                            <Dropdown
                              overlay={fontFamilyMenu(
                                handleSwitchXAxisFontFamily
                              )}
                            >
                              <span>
                                {xAxisfontFamily} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                        <div style={{ flexGrow: 5 }}>
                          <label>横轴字号</label>
                          <div>
                            <Dropdown
                              overlay={fontSizeMenu(handleSwitchXAxisFontSize)}
                            >
                              <span>
                                {xAxisfontSize} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                      <div>
                        <Popover
                          placement="leftTop"
                          title={"字体颜色"}
                          content={
                            <SketchPicker
                              color={xAxisFontColor}
                              onChangeComplete={handleSwitchXAxisFontColor}
                            ></SketchPicker>
                          }
                          trigger="click"
                        >
                          <Tag
                            color={xAxisFontColor}
                            style={{ cursor: "pointer" }}
                          >
                            字体颜色
                          </Tag>
                        </Popover>
                      </div>
                      <div className="option-item">
                        <label>倾斜角</label>
                        <Dropdown
                          overlay={customMenu(
                            handleSwitchXAxisRotate,
                            rotateList
                          )}
                        >
                          <span>
                            {xAxisroTate} <DownOutlined />
                          </span>
                        </Dropdown>
                      </div>
                      <div className="option-item">
                        <label>反转</label>
                        <Switch
                          defaultChecked={false}
                          onChange={(checked: any) => {
                            setOption({
                              xAxis: {
                                inverse: checked,
                              },
                            });
                          }}
                        />
                      </div>
                    </Panel>
                  )}
                  {type === "饼图" ? (
                    ""
                  ) : (
                    <Panel header="纵轴" key="5">
                      <div className="option-item">
                        <Input
                          size="large"
                          placeholder={yAxisTitle}
                          onChange={(event: any) => {
                            setYAxisTitle(event.target.value);
                            setOption({
                              yAxis: {
                                name: event.target.value,
                              },
                            });
                          }}
                        ></Input>
                      </div>
                      <div style={{ display: "flex" }} className="option-item">
                        <div style={{ flexGrow: 5 }}>
                          <label>标题字体</label>
                          <div>
                            <Dropdown
                              overlay={fontFamilyMenu(
                                handleSwitchYAxisTitleFontFamily
                              )}
                            >
                              <span>
                                {yAxisTitleFontFamily} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                        <div style={{ flexGrow: 5 }}>
                          <label>标题字号</label>
                          <div>
                            <Dropdown
                              overlay={fontSizeMenu(
                                handleSwitchYAxisTitleFontSize
                              )}
                            >
                              <span>
                                {yAxisTitleFontSize} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                      <div className="option-item">
                        <Popover
                          placement="leftTop"
                          title={"字体颜色"}
                          content={
                            <SketchPicker
                              color={yAxisTitleFontColor}
                              onChangeComplete={handleSwitchYAxisTitleFontColor}
                            ></SketchPicker>
                          }
                          trigger="click"
                        >
                          <Tag
                            color={yAxisTitleFontColor}
                            style={{ cursor: "pointer" }}
                          >
                            标题颜色
                          </Tag>
                        </Popover>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flexGrow: 5 }}>
                          <label>纵轴字体</label>
                          <div>
                            <Dropdown
                              overlay={fontFamilyMenu(
                                handleSwitchYAxisFontFamily
                              )}
                            >
                              <span>
                                {yAxisfontFamily} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                        <div style={{ flexGrow: 5 }}>
                          <label>纵轴字号</label>
                          <div>
                            <Dropdown
                              overlay={fontSizeMenu(handleSwitchYAxisFontSize)}
                            >
                              <span>
                                {yAxisfontSize} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                      <div className="option-item">
                        <Popover
                          placement="leftTop"
                          title={"字体颜色"}
                          content={
                            <SketchPicker
                              color={yAxisFontColor}
                              onChangeComplete={handleSwitchYAxisFontColor}
                            ></SketchPicker>
                          }
                          trigger="click"
                        >
                          <Tag
                            color={yAxisFontColor}
                            style={{ cursor: "pointer" }}
                          >
                            字体颜色
                          </Tag>
                        </Popover>
                      </div>
                      <div className="option-item">
                        <label>倾斜角</label>
                        <Dropdown
                          overlay={customMenu(
                            handleSwitchYAxisRotate,
                            rotateList
                          )}
                        >
                          <span>
                            {yAxisroTate} <DownOutlined />
                          </span>
                        </Dropdown>
                      </div>
                    </Panel>
                  )}
                  {type === "饼图" ? (
                    ""
                  ) : (
                    <Panel header="系列" key="7">
                      <div className="option-item">
                        {optionSource.series.map((s) => {
                          return (
                            <Series
                              name={s.name}
                              optionSource={option}
                              setOption={setOption}
                              setOptionSource={setOptionSource}
                              key={s.name}
                            ></Series>
                          );
                        })}
                      </div>
                      <div className="option-item">
                        <label>数据标签</label>
                        <label>位置</label>
                        <Dropdown
                          overlay={customMenu(
                            handleSwitchDataPostion,
                            dataPositionList
                          )}
                        >
                          <span>
                            {dataPosition} <DownOutlined />
                          </span>
                        </Dropdown>
                      </div>
                      <div style={{ display: "flex" }} className="option-item">
                        <div style={{ flexGrow: 5 }}>
                          <label>数据字体</label>
                          <div>
                            <Dropdown
                              overlay={fontFamilyMenu(
                                handleSwitchDataFontFamily
                              )}
                            >
                              <span>
                                {dataFontFamily} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                        <div style={{ flexGrow: 5 }}>
                          <label>数据字号</label>
                          <div>
                            <Dropdown
                              overlay={fontSizeMenu(handleSwitchDataFontSize)}
                            >
                              <span>
                                {dataFontSize} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                      <div className="option-item">
                        <Popover
                          placement="leftTop"
                          title={"字体颜色"}
                          content={
                            <SketchPicker
                              color={dataFontColor}
                              onChangeComplete={handleSwitchDataFontColor}
                            ></SketchPicker>
                          }
                          trigger="click"
                        >
                          <Tag
                            color={dataFontColor}
                            style={{ cursor: "pointer" }}
                          >
                            数据字体颜色
                          </Tag>
                        </Popover>
                      </div>
                      {type === "折线图" || type === "面积图" ? (
                        <div className="option-item">
                          <label>折线类型</label>
                          <div>
                            <Dropdown
                              overlay={customMenu(
                                handleSwitchLineStyle,
                                lineType
                              )}
                            >
                              <span>
                                {lineStyle} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                          <label>折线宽度</label>
                          <div>
                            <Dropdown
                              overlay={customMenu(
                                handleSwitchLineWidth,
                                lineWidthList
                              )}
                            >
                              <span>
                                {lineWidth} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {type === "散点图" ||
                      type === "折线图" ||
                      type === "面积图" ? (
                        <div className="option-item">
                          <label>折点图标</label>
                          <div>
                            <Dropdown
                              overlay={customMenu(
                                handleSwitchSymbol,
                                symbolList
                              )}
                            >
                              <span>
                                {lineSymbol} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                          <label>图标大小</label>
                          <div className="option-item">
                            <Dropdown
                              overlay={customMenu(
                                handleSwitchSymbolSize,
                                lineWidthList
                              )}
                            >
                              <span>
                                {lineSymbolSize} <DownOutlined />
                              </span>
                            </Dropdown>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Panel>
                  )}
                  {type === "饼图" ? (
                    <Panel header="饼图" key="19">
                      <div className="option-item">
                        <label>圆环大小</label>
                        <div>
                          <Dropdown
                            overlay={customMenu(
                              handleSwitchPieRadius,
                              radiusList
                            )}
                          >
                            <span>
                              {pieRadius} <DownOutlined />
                            </span>
                          </Dropdown>
                        </div>
                        <label>
                          {showAllInfo ? "隐藏具体信息" : "显示具体信息"}
                        </label>
                        <div>
                          <Switch
                            defaultChecked={true}
                            onChange={handleSwitchShowAllInfo}
                          />
                        </div>
                        <div>
                          <Dropdown
                            overlay={customMenu(
                              (name: string) => {
                                setCurrentPiePart(name);
                                const copyOption = { ...option };
                                const data = copyOption.series[0].data.find(
                                  (d: any) => {
                                    return d.name === name;
                                  }
                                );
                                if (data.itemStyle && data.itemStyle.color)
                                  setCurrentPiePartColor(data.itemStyle.color);
                              },
                              option2.series[0].data.map((d) => {
                                return d.name;
                              })
                            )}
                          >
                            <span>
                              {currentPiePart} <DownOutlined />
                            </span>
                          </Dropdown>
                          <div></div>
                          {/* <Popover
                            placement="leftTop"
                            title={"背景颜色"}
                            content={
                              <SketchPicker
                                color={currentPiePartColor}
                                onChangeComplete={(color: any) => {
                                  setCurrentPiePartColor(color.hex);
                                  const copyOption = JSON.parse(
                                    JSON.stringify(option)
                                  );
                                  if (copyOption.series) {
                                    const data = copyOption.series[0].data.find(
                                      (d: any) => {
                                        return d.name === currentPiePart;
                                      }
                                    );
                                    data.itemStyle = {
                                      color: color.hex,
                                    };
                                    setOption(copyOption);
                                  }
                                }}
                              ></SketchPicker>
                            }
                            trigger="click"
                          >
                            <Tag
                              color={currentPiePartColor}
                              style={{ cursor: "pointer" }}
                            >
                              扇形颜色
                            </Tag>
                          </Popover> */}
                        </div>
                      </div>
                    </Panel>
                  ) : (
                    ""
                  )}
                </Collapse>
              </TabPane>
            </Tabs>
          </Drawer>
        </div>
      </div>
    </div>
  );
}

export default App;
